    /* list out of stck product last collection start */
    // Find the <li> elements with the class "out of stock"
    var outOfStockItems = document.querySelectorAll('.grid__item.grid-product.out-of-stock');
    // Move the out-of-stock items to the end of the parent container
    outOfStockItems.forEach(function (item) {
      item.parentNode.appendChild(item);
    });
    var targetClass = ".grid-product";
    function isMobileWidth() {
      return window.innerWidth <= 768; // Adjust the breakpoint as needed
    }
    // Loop through each element with the target class
    document.querySelectorAll(targetClass).forEach(function (el) {
      var firstPosition = parseInt(isMobileWidth() ? el.dataset.mobilePosition : el.dataset.firstPosition, 10);
      var currentTargets = document.querySelectorAll(targetClass);
      // Move the <li> element to the desired position
      if (firstPosition > 0 && firstPosition <= currentTargets.length) {
        var referenceEl = currentTargets[firstPosition];
        if (referenceEl) {
          referenceEl.parentNode.insertBefore(el, referenceEl.nextSibling);
        }
      }
    });
    /* list out of stck product last collection end */
